<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines" :inline="true">
        <div class="u-f u-ac u-jsb">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              size="small"
              @click="handleAdd"
              >新增
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" :height="height" border v-loading="loading">
        <el-table-column prop="name" label="标签名"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.row, scope.$index)"
            ></el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelet(scope.row, scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="设置"
      :visible.sync="dialogVisible"
      center
      top="20px"
      class="dialogs"
    >
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form
          :model="ruleForm"
          :rules="rule"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-form-item label="标签名" prop="name">
            <el-input
              v-model="ruleForm.name"
              size="small"
              class="gg_wid"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="submit('ruleForm')"
          size="small"
          type="primary"
          :loading="subloading"
          >提 交</el-button
        >
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      lb_options: [],
      currentPage: 1,
      pagesize: 15,
      count: 0,
      height: null,
      eid: "",
      dialogVisible: false,
      subloading: false,
      ruleForm: {
        name: "",
      },
      rule: {
        name: [
          {
            required: true,
            message: "请填写标签名",
            trigger: "blur",
          },
        ],
      },
      state: 0,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },
  mounted() {
    let that = this;
    that.getHeight();
    that.begin();
  },
  methods: {
    getHeight() {
      let that = this;
      var titles = that.$refs.titles.offsetHeight;
      that.height = window.innerHeight - titles - 200 + "px";
      window.onresize = () => {
        var titles = that.$refs.titles.offsetHeight;
        that.height = window.innerHeight - titles - 200 + "px";
      };
    },
    // 搜索
    begin() {
      let that = this;
      that.currentPage = 1;
      that.pagesize = 15;
      that.search();
    },
    search() {
      let that = this;
      that.loading = true;

      axios
        .get(`/admin/user_label/${that.currentPage}?limit=${that.pagesize}`, {
          token: true,
        })
        .then((res) => {
          that.loading = false;
          that.tableData = res.data.data.list;
          that.count = res.data.data.count;
        })
        .catch((error) => {});
    },
    handleSizeChange(val) {
      let that = this;
      that.pagesize = val;
      that.search();
    },
    handleCurrentChange(val) {
      let that = this;
      that.currentPage = val;
      that.search();
    },
    handleAdd() {
      let that = this;
      that.dialogVisible = true;
      that.eid = "";
      that.form_clear();
      this.state = 0;
    },
    form_clear() {
      let that = this;
      that.ruleForm = {
        name: "",
        url: "",
        list: [
          {
            name: "",
            e_name: "",
            fraction: "",
            day_limit: "",
            total_limit: "",
          },
        ],
      };
    },
    handleAdds() {
      let that = this;
      that.ruleForm.list.push({
        name: "",
        e_name: "",
        fraction: "",
        day_limit: "",
        total_limit: "",
      });
    },
    delxx(index) {
      this.ruleForm.list.splice(index, 1);
    },
    submit(formName) {
      if (this.state == 0) {
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.subloading = true;
            axios
              .post(
                "admin/user_label/Msave",
                {
                  name: that.ruleForm.name,
                },
                {
                  token: true,
                }
              )
              .then((response) => {
                that.subloading = false;
                if (response.data.code == "200") {
                  that.dialogVisible = false;
                  that.search();
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {
                that.subloading = false;
              });
          } else {
            return false;
          }
        });
      } else {
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.subloading = true;
            axios
              .post(
                "admin/user_label/Mupdate",
                {
                  id: that.eid,
                  name: that.ruleForm.name,
                },
                {
                  token: true,
                }
              )
              .then((response) => {
                that.subloading = false;
                if (response.data.code == "200") {
                  that.dialogVisible = false;
                  that.search();
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {
                that.subloading = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    // 编辑
    handleEdit(row, index) {
      let that = this;
      this.state = 1;
      that.dialogVisible = true;
      that.eid = row.id;
      that.ruleForm.name = row.name;
    },
    // 删除
    handleDelet(row, index) {
      let that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .post(
              "/admin/user_label/Mdel",
              {
                id: row.id,
              },
              {
                token: true,
              }
            )
            .then((response) => {
              if (response.data.code == "200") {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                that.search();
              } else {
                that.$message.error(response.data.msg);
              }
            })
            .catch((error) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>


<style scoped>
.gg_box {
  border: 1px dashed rgb(204, 204, 204);
  padding: 10px 0px 10px 0;
  margin-top: 10px;
}

.gg_wid {
  width: 80%;
}
</style>